// core/store.js — createStore: a tiny observable value. get / set / subscribe. One store = one value.
//
// Extracted (frontend_view-state-base, Phase base) from MapStateStore's real Set-based subscribe — the
// only genuine notify mechanism in the codebase (TagStore uses the mediator, OverlayState none).
// Deliberately minimal: per-key patches, named domain events and snapshots are wrappers ON TOP, not here.

export function createStore(initial) {
    let state = initial;
    const listeners = new Set();
    return {
        // Current state.
        get() { return state; },
        // Replace the state with `next` (a value) or `updater(prev) => next`; notifies every subscriber
        // with the new state. Returns the new state. (Merge/patch is a consumer concern: set(s => ({...s, ...})).)
        set(next) {
            state = typeof next === 'function' ? next(state) : next;
            for (const fn of listeners) { fn(state); }
            return state;
        },
        // Register a listener fn(state); returns an unsubscribe function (pair it with a DisposerBag).
        subscribe(fn) {
            listeners.add(fn);
            return () => listeners.delete(fn);
        },
    };
}
